import UserRepository from "@domain/repositories/UserRepository";
import UseCase from "@domain/UseCase";
import { User } from "@domain/models/User";

type Input = void;

type Output = Promise<User>;

export class GetUserUseCase implements UseCase<Input, Output> {
  constructor(private readonly userRepository: UserRepository) {
    this.userRepository = userRepository;
  }
  async execute(): Promise<User> {
    return this.userRepository.get();
  }
}
